import React from 'react';

import MarginAuto from '../../common/MarginAuto';
import RatioModelisation from './RatioModelisation/RatioModelisation';

function SpeechRatio({ value = 0 }: { value?: number }) {
    return (
        <MarginAuto>
            <RatioModelisation value={value} />
        </MarginAuto>
    );
}

export default SpeechRatio;
